<template>
  <div class="page-index">
    <div class="index-banner" v-if="banner_list.length>0">
      <div class="search-cover">
        <product-search
          :citylist="citylist"
          :city_name="city_name"
          ref="searchCom"
          @transferKw="serchGoods"
        />
      </div>
      <div class="swiper-container gallery-top">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide zoomImage"
            v-for="(item,index) in banner_list"
            :key="index"
            :style="'background-image:url('+item.pic+')'"
            @click="jumpTo(item)"
          ></div>
        </div>
      </div>
      <div class="swiper-container gallery-thumbs">
        <div class="swiper-wrapper" style="height:51.7px">
          <div
            class="swiper-slide d"
            style="height:51.7px"
            v-for="(item,index) in banner_list"
            :key="index"
          >
            <img :src="item.pic" alt="轮播图">
          </div>
        </div>
      </div>
      <!-- <index-swiper :list="banner_list" /> -->
    </div>
    <!-- 分类开始 -->
    <div class="index-cate" v-if="category_list.length>0">
      <div class="container">
        <ul class="col-xs-12">
          <li v-for="(item, index) in category_list" :key="index">
            <router-link :to="{path:'/GoodsList', query:{cid:item.id}}">
              <img v-lazy="imgHandle(item.app_image,index)" :key="item.web_image">
              <span class="text-overflow">{{item.name}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- 分类结束 -->
    <!-- 特价租品开始 -->
    <div class="index-products" v-if="special_list.length>0">
      <div class="container products-box">
        <div class="products-top">
          <div class="icon-box">
            <img src="/static/img/tejia@1x.png" alt="">
            <span>特价租品</span>
          </div>
        </div>
        <slide-list class="my-slide" :list="special_list"/>
      </div>
    </div>
    <!-- 特价租品结束 -->
    <!-- 热租租品开始 -->
    <div class="index-products" v-if="hot_list.length>0">
      <div class="container products-box">
        <div class="products-top">
          <div class="icon-box">
            <img src="/static/img/rezu@1x.png" alt="">
            <span style="color: #f12a0e">热销租品</span>
          </div>
        </div>
        <slide-list class="my-slide" :list="hot_list"/>
      </div>
    </div>
    <!-- 热租租品结束 -->
    <!-- 首页推荐分类租品开始 -->
    <div v-if="indexgoods_list.length>0">
      <div v-for="(items, index) in indexgoods_list" :key="index">
        <div class="index-products" v-if="items.goods_arr.length>0">
          <div class="container products-box">
            <div class="products-top">
              <div class="icon-box">
                <b></b>
                <span style="color:#FA6665">{{items.name}}</span>
              </div>
              <router-link :to="{path:'/GoodsList', query:{cid:items.id}}">
                <div class="more-box">
                  更多
                  <i class="el-icon-arrow-right f12"></i>
                </div>
              </router-link>
            </div>
            <slide-list class="my-slide" :list="items.goods_arr"/>
          </div>
        </div>
      </div>
    </div>
    <!-- 五步流程组件 -->
    <index-process/>
  </div>
</template>
<script>
import { categoryList2, cityList, homeData } from "../api/index";

export default {
  name: "HelloWorld",
  data() {
    return {
      keywords: "",
      citylist: [],
      city_name:
        !this.$cookies.get("city_name") ||
        this.$cookies.get("city_name") == "undefined"
          ? "北京"
          : (this.$cookies.get("city_name")||"北京"),
      city_id:
        !this.$cookies.get("city_id") ||
        this.$cookies.get("city_id") == "undefined"
          ? 52
          : this.$cookies.get("city_id"),
      banner_list: [],
      hot_list: [],
      special_list: [],
      category_list: [],
      indexgoods_list: []
    };
  },
  components: {
    indexProcess: resolve =>
      require(["../components/indexProcess.vue"], resolve),
    productSearch: resolve =>
      require(["../components/productSearch.vue"], resolve),
    slideList: resolve => require(["../components/slideList"], resolve),
    indexSwiper: resolve => require(["../components/indexSwiper"], resolve)
  },
  methods: {
    //轮播图跳转链接
    jumpTo: function(e) {
      var url = e.link_url;
      if (e.jump_type == 4) {
        //跳转到自定义页面
      } else if (e.jump_type == 3) {
        if (url.indexOf("mywallet") > -1) {
          this.$router.push("/mywallet");
        } else if (url.indexOf("myline") > -1) {
          this.$router.push("/download");
        } else {
          window.open(url, "_blank");
        }
      } else if (e.jump_type == 2) {
        let routeData = this.$router.resolve({
          path: "/SupplierDetail",
          query: { id: e.supplier_id }
        });
        window.open(routeData.href, "_blank");
      } else if (e.jump_type == 1) {
        let routeData = this.$router.resolve({
          path: "/GoodsDetail",
          query: { id: e.goods_id }
        });
        window.open(routeData.href, "_blank");
      }
    },
    //获取分类
    getCategory() {
      categoryList2().then(response => {
        if (response.data.code != "error") {
          if (response.data.data.length > 0) {
            response.data.data[response.data.data.length - 1] = {
              app_image: "../../static/img/gengduofenlei @2x.png",
              id: 0,
              name: "更多",
              web_image: "../../static/img/gengduofenlei @2x.png",
            };
          }
          this.category_list = response.data.data || [];
        }
      });
    },
    //获取城市列表
    getCityData() {
      cityList().then(res => {
        if (res.data.code != "error") {
          this.citylist = res.data.data || [];
          this.$cookies.set(
            "citylist",
            JSON.stringify(res.data.data),
            60 * 60 * 24
          );
        }
      });
    },
    //搜索
    serchGoods(keywords) {
      this.$refs.searchCom.keywords = "";
      this.$router.push({
        path: "/GoodsList",
        query: {
          keywords: keywords,
          supplier_id: 0
        }
      });
    },
    //聚合接口
    homeData() {
      var params = {
        city_id: this.city_id,
        position: 1
      };
      homeData(params).then(response => {
        if (response.data.code != "error") {
          this.banner_list = response.data.data.banner_list || [];
          this.indexgoods_list =
            response.data.data.home_category_goods_list || [];
          this.special_list = response.data.data.special_goods_list.data || [];
          this.hot_list = response.data.data.hot_goods_list.data || [];
          this.$nextTick(function() {
            if (!!this.banner_list) {
              this.swiperint();
            }
          });
        }
      });
    },
    //轮播图初始化
    swiperint() {
      var galleryThumbs = new Swiper(".gallery-thumbs", {
        direction: "vertical",
        slidesPerView: 5,
        loopedSlides: 5,
        watchSlidesVisibility: true,
        watchSlidesProgress: true
      });
      var galleryTop = new Swiper(".gallery-top", {
        autoplay: {
          delay: 5000
        },
        effect: "fade",
        loop: true,
        loopedSlides: 5,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        thumbs: {
          swiper: galleryThumbs
        }
      });
    },
    initData() {
      this.$cookies.set("city_is_changed", false);
      this.getCategory();
      this.getCityData();
      this.homeData();
    },
    imgHandle(url,index){
      if(index!=11&&url&&url.indexOf('https://qn.dazuhang.com/')==-1){
        url='https://qn.dazuhang.com/'+url
      }
      return url;
    }
  },
  created() {
    this.initData();
  }
};
</script>

<style lang="scss" scoped>
ul {
  padding: 0;
}
li {
  margin: 0 10px;
}
a {
  color: #42b983;
}

.index-banner {
  position: relative;
}
.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.index-cate {
  background: #fff;
  padding: 20px 0;
}
.index-cate ul {
  width: 100%;
  overflow: hidden;
}
.index-cate ul li {
  width: 14.6%;
  padding: 10px;
  float: left;
  cursor: pointer;
}
.index-cate ul li:hover span {
  color: orange;
}
.index-cate ul li img {
  width: 115px;
  height: 115px;
  display: block;
  margin: 0 auto;
  opacity: 0.8;
}
.index-cate ul li:hover img {
  opacity: 1;
}
.index-cate ul li span {
  display: block;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
  color: #333;
}

.index-products {
  margin-top: 30px;
}
.products-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
}
.products-top div {
  display: flex;
  align-items: center;
}
.products-top div img {
  width: 27px;
  height: 30px;
  margin-right: 15px;
}
.products-top .icon-box span {
  font-size: 22px;
  color: #f9b50b;
}

.icon-box b {
  width: 13px;
  height: 35px;
  display: block;
  margin-right: 30px;
  background: #fa6665;
}
.products-box {
  background: #fff;
  padding: 20px 15px;
}
.products-top .more-box {
  font-size: 12px;
  cursor: pointer;
  color: #999;
}
.products-top .more-box:hover {
  color: #ff6b56;
}
.products-top .more-box img {
  width: 8px;
  height: 14px;
  margin-left: 15px;
}

.page-index {
  background: rgb(245, 245, 245);
}
.swiper-container {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.gallery-top {
  height: 100%;
  width: 100%;
  position: relative;
}
.gallery-thumbs {
  box-sizing: border-box;
  position: absolute;
  top: 37px;
  width: 96px;
  height: 259px;
  right: 40px;
  overflow: unset;
}
.gallery-thumbs .swiper-slide {
  height: 100%;
}
.gallery-thumbs .swiper-slide-thumb-active {
  transform: scale(1.2);
  z-index: 100;
  box-shadow: 0 0 4px 2px gold;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}
.search-cover {
  width: 500px;
  position: absolute;
  bottom: 38px;
  z-index: 200;
  font-size: 12px;
  padding: 10px 10px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
  left: 0;
  right: 0;
  margin: 0 auto;
}

.zoomImage {
  width: 100%;
  height: 0;
  padding-bottom: calc(69 / 192 * 100%);
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
}

.my-slide {
  padding: 10px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/HelloWorld.vue